module.exports = "https://la-static.vkplay.ru/promo/universal/img/pic-1.5ed4acbd.png";